(function () {
  var root = document.documentElement;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  root.classList.add("frs-js");

  function setRevealDelays(section) {
    var items = section.querySelectorAll("[data-frs-reveal]");

    items.forEach(function (item, index) {
      item.style.setProperty("--frs-delay", Math.min(index * 120, 480) + "ms");
    });
  }

  function revealItem(item) {
    item.classList.add("frs-is-visible");
  }

  function initReveal(section) {
    var revealItems = section.querySelectorAll("[data-frs-reveal]");

    setRevealDelays(section);

    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealItems.forEach(revealItem);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          revealItem(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.frsInitialized === "true") {
      return;
    }

    section.dataset.frsInitialized = "true";
    initReveal(section);
  }

  function initAll() {
    document.querySelectorAll("[data-frs-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector("[data-frs-section]"));
  });
})();
